'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import * as React from 'react'

/* -----------------------------------------------------------------------------
 * useLoadingState
 * -------------------------------------------------------------------------- */

export type LoadingState = {
  error?: any
  isLoaded: boolean
  isReloading: boolean
}

const useLoadingState = (
  func: () => Promise<any>,
  deps: React.DependencyList = []
): LoadingState => {
  const [{ error, isLoaded, isReloading }, setState] =
    React.useState<LoadingState>({ isLoaded: false, isReloading: false })

  const onLoad = async () => {
    let error
    setState({ isLoaded, isReloading: true })
    try {
      await func()
    } catch (e) {
      error = e
    }
    setState({ error, isLoaded: true, isReloading: false })
  }

  React.useEffect(() => {
    onLoad()
  }, deps)

  return { error, isLoaded, isReloading }
}

export default useLoadingState
